import { Injectable, signal } from '@angular/core';

/** Tracks whether the off-canvas sidebar drawer is open on narrow viewports, and whether the
 * inline (desktop) sidebar is collapsed to an icon-only rail. */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly sidebarOpen = signal(false);
  readonly sidebarCollapsed = signal(false);

  toggleSidebar(): void {
    this.sidebarOpen.update((open) => !open);
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }

  toggleSidebarCollapsed(): void {
    this.sidebarCollapsed.update((collapsed) => !collapsed);
  }
}
